import React from 'react'
import { Flex, List, Avatar, Divider } from 'antd'
import { isDesktop } from 'react-device-detect'
import AVATAR from '../img/avatar/avatar.png'
import AIRTON from '../img/avatar/airton marques.jpg'
import MARIA from '../img/avatar/Maria Eugenia.jpg'
import ARY from '../img/avatar/Ary Marques.jpg'
import HILUY from '../img/avatar/Hiluy.jpg'
import JOAO from '../img/avatar/Joaao Aldesio.png'
import ALCIONE from '../img/avatar/Alcione.jpg'
import CELIA from '../img/avatar/Celia.jpg'
import { icons } from 'antd/es/image/PreviewGroup'


export const QuemSomos = () => {

    const data = [
        { title: "Presidente", nome: "Airton marques da Silva", icon: AIRTON },
        { title: "Vice-Presidente", nome: "Maria Eugênia Silva Vargas", icon: MARIA },
        { title: "Diretor Tesoureiro", nome: "Ary Marques da Silva", icon: ARY },
        { title: "Diretora Secretária", nome: "Rosa Ferreira de Arújo Abreu", icon: AVATAR },
        { title: "Diretor Técnico-Científico", nome: "Renato Azevedo Moreira", icon: AVATAR },
    ]

    const data2 = [
        { title: "Titular", nome: "Antonio Renato Soares de Casimiro", icon: MARIA },
        { title: "Titular", nome: "Antonio carlos Magalhâes", icon: AVATAR },
        { title: "Titular", nome: "João José Hiluy Filho", icon: HILUY },
        { title: "Suplente", nome: "Maria de Fátima Santana Neves", icon: AVATAR },
    ]

    const data3 = [
        { title: "Cadeira ", nome: "Maria Iracema Lacerda Machado", icon: AVATAR },
        { title: "Cadeira ", nome: "Iêda Nadja Silva Montenegro", icon: AVATAR },
        { title: "Cadeira ", nome: "Nilce Viana Gramosa Pompeu de Sousa Brasil", icon: AVATAR },
        { title: "Cadeira ", nome: "João José Hiluy Filho", icon: HILUY },
        { title: "Cadeira ", nome: "Petrônio Augusto Pinheiro", icon: AVATAR },
        { title: "Cadeira ", nome: "Afrânio Aragão Craveiro", icon: AVATAR },
        { title: "Cadeira ", nome: "Ary Marques da Silva", icon: ARY },
        { title: "Cadeira ", nome: "José Everardo Xavieer de Matos", icon: AVATAR },
        { title: "Cadeira ", nome: "Renato de Azevedo Moreira", icon: AVATAR },
        { title: "Cadeira ", nome: "João Aldésio Pinheiro Holanda", icon: JOAO },
        { title: "Cadeira ", nome: "Pedro de Lima Neto", icon: AVATAR },
        { title: "Cadeira ", nome: "Roberto Lima Sampaio", icon: AVATAR },
        { title: "Cadeira ", nome: "José Osvaldo Bezerra Carioca", icon: AVATAR },
        { title: "Cadeira ", nome: "Airton Marques da Silva", icon: AIRTON },
        { title: "Cadeira ", nome: "Sérgio Maia Melo", icon: AVATAR },
        { title: "Cadeira ", nome: "Francisco Belmino Romero", icon: AVATAR },
        { title: "Cadeira ", nome: "Manoel Andrade Neto", icon: AVATAR },
        { title: "Cadeira ", nome: "Antonio Carlos Magalhães", icon: AVATAR },
        { title: "Cadeira ", nome: "Antonio Renato Soares de Casemiro", icon: AVATAR },
        { title: "Cadeira ", nome: "Raimundo Guilherme Campos Correa", icon: AVATAR },
        { title: "Cadeira ", nome: "Nadja Maria Sales de Vasconcelos", icon: AVATAR },
        { title: "Cadeira ", nome: "Maria Eugênia Silva Vargas", icon: MARIA },
        { title: "Cadeira ", nome: "Maria Alcione Almeida Chagas", icon: ALCIONE },
        { title: "Cadeira ", nome: "Maria de Fátima Santana Neves", icon: AVATAR },
        { title: "Cadeira ", nome: "Célia Maria C. da Cunha Diógenes Nogueira", icon: CELIA },
        { title: "Cadeira ", nome: "Selene Maia de Morais", icon: AVATAR },
        { title: "Cadeira ", nome: "Emelvira Bravo de Paiva e Sá", icon: AVATAR },
        { title: "Cadeira ", nome: "Nágila maria Ponte Silva Ricardo", icon: AVATAR },
        { title: "Cadeira ", nome: "Cláudio Ricardo Gomes de Lima", icon: AVATAR },
        { title: "Cadeira ", nome: "Maria Mozarina Beserra Almeida", icon: AVATAR },
        { title: "Cadeira ", nome: "Rosa Ferreira de Araújo Abreu", icon: AVATAR },
        { title: "Cadeira ", nome: "Ronaldo Ferreira do Nascimento", icon: AVATAR },
        { title: "Cadeira ", nome: "Diana Cristina Silva de Azevedo", icon: AVATAR },
        { title: "Cadeira ", nome: "Maria da Conceição Ferreira de Oliveira", icon: AVATAR },
    ]



    return <Flex vertical align='center' justify='center'>
        <Flex
            gap={10}
            style={{ padding: 25, width: isDesktop ? 1024 : '100%', backgroundColor: 'white' }}
            vertical
            justify='center' >
            <h2>Diretoria Executiva</h2>
            <List            
                size='small'
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta
                            avatar={<Avatar size={"large"} src={item.icon} />}
                            title={item.title}
                            description={<Flex style={{ color: '#000' }}>{item.nome} </Flex>}
                        />
                    </List.Item>
                )}
            />

            <Divider />

            <h2>Conselho Fiscal</h2>
            <List
                size='small'
                itemLayout="horizontal"
                dataSource={data2}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta
                            avatar={<Avatar size={'large'} src={item.icon} />}
                            title={item.title}
                            description={item.nome}
                        />
                    </List.Item>
                )}
            />

            <Divider />
            <h2>Acadêmicos</h2>
            <List
            style={{marginBottom:25}}
                size='small'
                itemLayout="horizontal"
                dataSource={data3}
                renderItem={(item, index) => (
                    <List.Item>
                        <List.Item.Meta
                            avatar={<Avatar size={'large'} src={item.icon} />}
                            title={item.title.concat(index + 1)}
                            description={item.nome}
                        />
                    </List.Item>
                )}
            />

        </Flex>
    </Flex>
}

export default QuemSomos